import { filterL, go, last } from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { PROCESSING_TASK } from "./const.js";
export const _handleMouseDownOnCanvasEl = (self, event) => {
  const rubber_band_layer_el = self._getRubberBandLayerElThrowable();
  const translate_transforming = self._getTranslateTransformingThrowable();
  const rubber_band = self._getRubberBandThrowable();
  const { clientX: x, clientY: y, target } = event;
  const mouse_down_point = self._toViewPortPoint({
    x,
    y,
  });
  self._mouse_down_position = {
    x: mouse_down_point.x,
    y: mouse_down_point.y,
  };
  switch (self._processing_task) {
    case null: {
      const el = (() => {
        if (target instanceof self._window.Node) {
          const target_node = target;
          return go(
            self._els.values(),
            filterL(({ wrapper_el }) => wrapper_el.contains(target_node)),
            last
          );
        }
        return null;
      })();
      if (el != null) {
        self.selectEls([el.id]);
        translate_transforming.start({
          x: mouse_down_point.x,
          y: mouse_down_point.y,
          els: [el.wrapper_el],
        });
        self._processing_task = PROCESSING_TASK.TRANSLATE_TRANSFORMING;
      } else {
        self.selectEls([]);
        const rubber_band_layer_ctm = rubber_band_layer_el.getCTM();
        if (rubber_band_layer_ctm == null) {
          return;
        }
        const rubber_band_layer_ctm_inverse = rubber_band_layer_ctm.inverse();
        const point = CommonNS.UtilNS.createSVGPoint(self._svg_el)([
          mouse_down_point.x,
          mouse_down_point.y,
        ]).matrixTransform(rubber_band_layer_ctm_inverse);
        rubber_band.startSelecting({
          x: point.x,
          y: point.y,
        });
        self._processing_task = PROCESSING_TASK.SELECTING;
      }
      return;
    }
    default: {
      return;
    }
  }
};
